<template>
  <div ref="characteristics" style="width:94%">
    <div class="mb-4" v-if="normalizedOptions.showClientName">
      <span class="faint">PATIENTENHALTER</span><br />
      {{ clientName }}
    </div>

    <div class="pb-1" v-if="normalizedOptions.showPetName">
      <span class="faint">NAME DES HUNDES</span> {{ pet.name }}
    </div>
    <div class="pb-1">
      <span class="faint">GESCHLECHT</span> {{ genderAndAdditionalInfo }}
    </div>
    <div class="pb-1"><span class="faint">RASSE</span> {{ pet.breedName }}</div>
    <div class="pb-1" v-if="pet.isMixedBreed"><span class="faint">RASSE 1</span> {{ pet.mixBreeds[0].name }}</div>
    <div class="pb-1" v-if="pet.isMixedBreed"><span class="faint">RASSE 2</span> {{ pet.mixBreeds[1].name }}</div>
    <div class="pb-1">
      <span class="faint">ALTER </span>
      <span v-if="age.years > 0">{{ age.years }} Jahre </span>
      <span v-if="age.months > 0">{{ age.months }} Monate</span>
    </div>
    <div class="pb-1">
      <span class="faint">GEWICHT</span> {{ pet.weight }} kg (BCS {{ pet.bcs }})
    </div>
    <div class="pb-1" v-if="pet.bcs !== 3">
      <span class="faint">ZIELGEWICHT</span> {{ pet.targetWeight }} kg
    </div>

    <div class="mt-4 faint">
      BESONDERHEITEN
    </div>
    <div class="">
      {{ additives }}
    </div>

    <div class="mt-4 faint">
      UNVERTRÄGLICHKEITEN
    </div>
    <div class="">
      {{ allergies }}
    </div>

    <div class="mt-4 faint">
      SPEZIFISCHE INDIKATIONEN
    </div>
    <div class="mb-2 mt-1">
      {{ illnesses }}
    </div>
    <div v-if="this.pet.additionalData.length > 0" class="row mt-2 mb-2">
      <div class="col-2">
        <img src="https://futalis.de/media/futalis/2022_Manuelle_Anpassung_Icon.svg" class="icon-manuelleAnpassung" alt="Manuelle_Anpassung_Icon">
      </div>
      <div class="col-10 pl-0">
        <div class="specific-indication" style="font-size: 14px">Unser tierärztliches Fachteam berücksichtigt Ihre Indikation
      </div>
      </div>
    </div>

    <div class="mb-4" v-if="pet.preferredFood > 0">
      <span class="faint">ROHSTOFFBASIS</span> <br />{{ pet.preferredFoodName }}
    </div>
  </div>
</template>

<script>
import {getPetAge} from "../../helpers/siteHelper";
import { CONSTANTS } from '@/constants/guide';
import {mapState} from "vuex";

const getDefaultOptions = () => {
  return {
    showClientName: true,
    showPetName: true,
    responsive: false
  };
};

export default {
  name: 'Characteristics',
  props: {
    pet: {
      type: Object,
      required: true
    },
    options: {
      required: false,
      type: Object,
      default: getDefaultOptions
    }
  },
  computed: {
    ...mapState({
      currentClient: state => state.configuratorModule.currentClient
    }),
    clientName: {
      get() {
        var name = this.currentClient?.name;
        if (typeof this.pet.clientName != 'undefined' && this.pet.clientName != '') {
          name = this.pet.clientName;
        }
        return name == '' ? 'noch nicht zugeordnet' : name;
      }
    },
    normalizedOptions() {
      return { ...getDefaultOptions(), ...this.options };
    },
    illnesses: {
      get() {
        let s_IllnessesIds= this.$store.state.configuratorModule.pet.s_illnesses.map(s_illness=> parseInt(s_illness.id));
        let result = '';
        let list = [];
        for (let i = 0; i < this.pet.illnesses.length; i++) {
          list.push(
            CONSTANTS.CONFIGURATOR.illnessesList[this.pet.illnesses[i]]
          );
        }
        result = list.join(', ');
        if (result === '' && (s_IllnessesIds.length >= 1 || this.pet.additionalData.length > 1)) {
          return '';
        } else if (result === '') {
          return 'keine';
        }
        return result;
      }
    },
    allergies: {
      get() {
        let result = '';
        let list = [];
        let allergies = this.pet.allergies.filter(function (value) {
          return parseInt(value) !== 46; // exclude Getreide (merged with 47)
        });
        for (let i = 0; i < allergies.length; i++) {
          list.push(
              CONSTANTS.CONFIGURATOR.allergiesList[allergies[i]]
          );
        }
        result = list.join(', ');
        if (result === '') {
          return 'keine';
        }
        return result;
      }
    },
    additives: {
      get() {
        let result = '';
        let list = [];
        const allAdditives = {
          ...CONSTANTS.CONFIGURATOR.additivesList,
          6: 'Zähne'
        };
        for (let i = 0; i < this.pet.additives.length; i++) {
          list.push(allAdditives[this.pet.additives[i]]);
        }
        result = list.join(', ');
        if (result === '') {
          return 'keine';
        }
        return result;
      }
    },
    genderAndAdditionalInfo: {
      get() {
        let result = '';
        result += this.pet.gender == 1 ? 'männlich' : 'weiblich';
        if (this.pet.neutered === true) {
          result += ', kastriert';
        }
        if (this.pet.breeding === true) {
          result += ', Zuchthund';
        }
        if (this.pet.gestation === true) {
          result += ', Trächtigkeit';
        }
        if (this.pet.lactation === true) {
          result += ', Laktation';
        }
        return result;
      }
    },
    age: {
      get() {
       return getPetAge(this.pet.birthYear, this.pet.birthMonth)
      }
    }
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped>
.faint {
  color: #aaa;
}
 .icon-manuelleAnpassung {
  position: relative;
  width: 28px;
  height: 38px;
  margin-left: -4px;
} 
@media (max-width: 768px) {
}
</style>
